/* eslint-disable */
const PREVIEW_STATE = {
	previewPdfPendingUserLogo: '',
	openUploadLogoFromPreviewFlag: false,
	whiteLabelledPdf: ''
};
export default PREVIEW_STATE;
